<template>
    <div
        ref="toolbarRoot"
        class="toolbar"
        :class="toolbarPosition"
        @change="handleToolbarChange"
        @pointerover="handlePointerOver"
        @pointerleave="handlePointerLeave"
        @pointerenter="handlePointerEnter"
        v-show="!store.onlyRead"
    >
        <div
            ref="toolbar"
            group="tool"
            @start="onMoveStart"
            @end="onMoveEnd"
            :move="onMoveTool"
            ghost-class="ghost-class"
            item-key="tools.TOOL"
            class="toolbar-content"
        >
            <template v-for="(element, index) in filterTools" :key="index">
                <div
                    :ref="'tool_' + element.TOOL"
                    class="tool"
                    :class="[
                        element.TOOL,
                        hoverCorner,
                        { selected: store.nowTool == element.TOOL },
                        { off: store.toggleTool[element.TOOL] },
                        { disabled: checkDisabled(element.TOOL) },
                        { disabled: checkPageIndex(element.TOOL) },
                    ]"
                    @pointerdown="handlePointerDown(element.TOOL, $event)"
                    :tag="element.TOOL"
                >
                    <div class="page-selector" v-if="element.TOOL == 'go_page'">
                        <input id="go_page_input" type="text" placeholder="請輸入頁碼" :value="nowPageName" />
                    </div>
                    <div class="tool-zoom-corner" v-if="element.TOOL == 'zoom_corner'">
                        <div
                            v-for="item in CORNER"
                            :class="item"
                            @pointerdown="triggerTool(element.TOOL + ':' + item)"
                            :key="element.TOOL + ':' + item"
                            @mouseover="hoverCorner = item"
                            @mouseout="hoverCorner = ''"
                        ></div>
                    </div>
                </div>
            </template>
        </div>
    </div>
    <div :style="dragZoneStyle" class="dragZone" ref="dragZone" v-show="store.isPenDrag"></div>
    <tool-box
        ref="toolBox"
        :nowTools="store.tools"
        :drag-zone="dragZone"
        :tool-bar-pointer-move="handleWindowPointerMove"
        :tool-bar="toolBarChildren"
        :tool-bar-pointer-up="handleWindowPointerUp"
    ></tool-box>
</template>

<script>
import { DEFAULT_TOOL, ALIVE_TYPE, NO_STOP_POLYGON_TOOLS, WEBVIEW_TYPE_DISABLE_TOOLS, MAC_DISABLE_TOOLS, APP_DISABLE_TOOLS } from "../js/toolbar/tools";
import EventBus from "../js/event_bus";
import draggable from "vuedraggable";
import Debugger from "../js/console/debugger";
import ToolBox from "./ToolBox.vue";
import { store } from "../store";
import { settingStore } from "../js/store/settingStore";
import { CORNER } from "../js/toolbar/tools";
import { TOOLS } from "../js/toolbar/tools";
import AppRenderer from "../js/app_renderer";
import { useUserStore } from "../js/user_data";
import SaveTool from "../js/toolbar/save_tool";
import PainterProxy from "../js/painter/proxy";
import { TURN_PAGE_TYPE } from "../js/book_define/turn_page_type";
import { windowContentScaleX, windowContentScaleY } from "../js/common/content_scale";
import { toolbarStore } from "../js/store/toolbarStore";
import { focusStore } from "../js/store/nowFocusStore";
import { EVENT_TYPE, getPointer } from "../js/event/event";
import { VIEW_TYPE } from "../js/view_type";
import GARecord from "../js/event_GArecord";
import SystemData from "../js/system_data";

export default {
    name: "ToolBar",
    data: function () {
        return {
            tools: [],
            drag: false,
            dragStartEvent: null,
            toolbarHeight: 0,
            canDelete: true,
            store,
            settingStore,
            nowPageName: "",
            debounce: null,
            CORNER,
            hoverCorner: "",
            elementToggle: {},
            userData: useUserStore(),
            isDragTool: false,
            toolPressed: null,

            dragZone: null,
            toolBarChildren: null,
            firstPointToolIndex: 0,

            firstPoint: { x: 0, y: 0 },
            currentDragToolSize: { width: 0, height: 0 },
            add: false,

            pointerType: "",
        };
    },
    components: {
        draggable,
        ToolBox,
    },
    methods: {
        // 觸發工具功能
        triggerTool(tool) {
            this.toolPressed = null;
            console.log("click tool:", tool);
            GARecord.Instance.toolClickGARecord(tool);
            const proxy = PainterProxy.getInstance();
            proxy.getCurrentPainter().painter.canvas.discardActiveObject();
            if (proxy.getCurrentPainter().painter.currentTool) {
                let isTrigger = true;
                for (let i = 0; i < NO_STOP_POLYGON_TOOLS.length; i++) {
                    if (NO_STOP_POLYGON_TOOLS[i].TOOL == tool) {
                        isTrigger = false;
                        break;
                    }
                }
                if (isTrigger) {
                    proxy.getCurrentPainter().painter.currentTool.mouseDBLClick();
                }
            }
            if (store.toolMap.get(tool)) {
                switch (store.toolMap.get(tool).KEEP_ALIVE) {
                    case ALIVE_TYPE.KEEP:
                        EventBus.getInstance().emit(tool);
                        store.nowTool = tool;
                        store.setPreviousTool(tool);
                        break;
                    case ALIVE_TYPE.ONCE:
                        EventBus.getInstance().emit(TOOLS.SELECTION.TOOL);
                        store.setPreviousTool(TOOLS.SELECTION.TOOL);
                        EventBus.getInstance().emit(tool);
                        store.nowTool = tool;
                        break;
                    case ALIVE_TYPE.NONE:
                        EventBus.getInstance().emit(tool);
                        console.log("prev tool:", store.prevTool);
                        store.nowTool = store.prevTool;
                        break;
                }
            } else {
                EventBus.getInstance().emit(tool);
                store.nowTool = store.prevTool;
            }

            if (tool == TOOLS.TOOL_BOX.TOOL) {
                return;
            }

            if (tool == TOOLS.GO_PAGE.TOOL) {
                return;
            }

            if (tool == TOOLS.WHITE_BOARD.TOOL) {
                store.setWhiteboardDisabledTools();
            }

            EventBus.getInstance().emit("close_tool_box");
            EventBus.getInstance().emit("close_quick_directory");
        },
        getToolBarHeight() {
            this.toolbarHeight = settingStore.toolbarPosition == 0 ? this.$refs.toolbarRoot.offsetHeight : 0;
            // this.toolbarHeight = settingStore.toolbarPosition == 0 ? this.$refs.toolbarRoot.getBoundingClientRect().height : 0;

            store.toolbarHeight = this.toolbarHeight;

            return this.toolbarHeight;
        },
        getToolBarWidth() {
            this.toolbarWidth = settingStore.toolbarPosition == 0 ? 0 : this.$refs.toolbarRoot.offsetWidth;
            store.toolbarWidth = this.toolbarWidth;

            return this.toolbarWidth;
        },
        onMoveTool({ relatedContext, draggedContext }) {
            return false; //return false --> cancel
            this.isDragTool = true;
            if (relatedContext.index == 0 || draggedContext.index == 0 || store.disabledTools.length > 0) {
                this.canDelete = false;
            }
            this.dragStartEvent.oldIndex = relatedContext.index;
        },
        handlePointerDown(tool, e) {
            if (tool == "tool_box") {
                this.canDelete = false;
            } else {
                this.canDelete = true;
            }
            this.isDragTool = false;
            if (this.toolPressed == null) {
                this.toolPressed = tool;
            }
            this.dragStartEvent = e;
            const pointer = getPointer(e);

            toolbarStore.prevPoint.x = pointer.x;
            toolbarStore.prevPoint.y = pointer.y;

            console.log(this.$refs.toolBox.show);

            this.pointerType = e.pointerType;

            if (e && this.canDelete == true && this.$refs.toolBox.show) {
                var clone = e.target.cloneNode();

                this.$refs.dragZone.append(clone);
                this.store.setDragIconPoint((pointer.x - 41) / windowContentScaleX, (pointer.y - 41) / windowContentScaleY);

                // this.$refs.toolbarRoot.style.pointerEvents = 'none';
                window.addEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.handleWindowPointerMove);
            }
            let node;
            if (tool == "zoom_corner" || tool == "go_page") {
                node = e.currentTarget;
            } else {
                node = e.target;
            }
            for (var i = 0; (node = node.previousSibling) != null; i++);
            this.dragStartEvent.oldIndex = i - 1;
            this.firstPointToolIndex = i - 1;
            window.addEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.handleWindowPointerUp);
        },
        onMoveStart(event) {
            this.dragStartEvent = event;
            store.editingToolBar = true;
        },
        onMoveEnd(event) {
            store.editingToolBar = false;
            if (!this.canDelete) return;
            if (store.disabledTools.length > 0) return;
            console.log("need to delete ?", this.checkToolNeedToDelete(event.originalEvent));
            if (this.checkToolNeedToDelete(event.originalEvent)) {
                // 拖曳到書頁的區域 returnValue會是true
                if (event.originalEvent.returnValue == true) {
                    console.trace("delete tool");
                    this.store.tools.splice(this.dragStartEvent.oldIndex, 1);
                    return;
                }
            }
            // 工具列拖曳時沒有交換到工具則會執行點擊到的工具的功能
            if (!this.isDragTool) {
                this.triggerTool(this.toolPressed);
                window.removeEventListener("pointerup", this.handleWindowPointerUp);
            }
        },
        switchToolBox(show) {
            if (show === undefined) {
                this.$refs.toolBox.show = !this.$refs.toolBox.show;
            } else {
                this.$refs.toolBox.show = show;
            }
            if (this.$refs.toolBox.show) {
                this.$refs.toolBox.handleDisplayTools();
            }
        },
        setToolsToDefault() {
            this.store.tools = DEFAULT_TOOL.slice();
        },
        pageDebounce(newValue) {
            const vm = this;
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                if (newValue.length == 0) return;
                vm.nowPageName = window.pageControl.gotoPageByName(newValue);
            }, 1000);
        },
        setPageName() {
            this.nowPageName = store.pageContent[store.nowBook][store.nowPage].pageName;
        },
        toggleQuickDirectory() {
            EventBus.getInstance().getAppRefs().quickDirectory.show = !EventBus.getInstance().getAppRefs().quickDirectory.show;
            EventBus.getInstance().getAppRefs().quickDirectory.message = "";
        },
        handleToolbarChange() {
            console.log("handle toolbar change");
        },
        handleWindowPointerMove(e) {
            const pointer = getPointer(e);

            const distanceX = pointer.x - toolbarStore.prevPoint.x;
            const distanceY = pointer.y - toolbarStore.prevPoint.y;
            if (!this.isDragTool && distanceX * distanceX + distanceY * distanceY < 9) {
                return;
            }
            console.log("start drag");
            this.isDragTool = true;
            this.store.isPenDrag = true;
            const toolbar = this.$refs.toolbarRoot.firstChild.children;
            const toolsCopy = this.store.tools.slice();

            // let deleteArr = toolsCopy.splice(this.dragStartEvent.oldIndex, 1);

            if (this.currentDragToolSize.width * this.currentDragToolSize.height == 0) {
                this.currentDragToolSize.width = toolbar.item(this.firstPointToolIndex).clientWidth;
                this.currentDragToolSize.height = toolbar.item(this.firstPointToolIndex).clientHeight;
            }

            const x = (pointer.x - store.contentSize.x - this.currentDragToolSize.width * 0.5) / windowContentScaleX.value;
            const y = (pointer.y + store.contentSize.y - this.currentDragToolSize.height * 0.5) / windowContentScaleY.value;
            this.store.setDragIconPoint(x, y);

            // console.log(`${pointer.y - store.contentSize.y} > ${store.contentSize.height - this.store.toolbarHeight}`);

            switch (settingStore.toolbarPosition) {
                case 0:
                    if (pointer.y - store.contentSize.y > store.contentSize.height - this.store.toolbarHeight) {
                        this.displayMovingTool(e, toolsCopy);
                    }
                    break;
                case 1:
                    if (pointer.x - store.contentSize.x < this.store.toolbarWidth) {
                        this.displayMovingTool(e, toolsCopy);
                    }
                    break;
                case 2:
                    if (pointer.x - store.contentSize.x > store.contentSize.width - this.store.toolbarWidth) {
                        this.displayMovingTool(e, toolsCopy);
                    }
                    break;
            }
        },
        displayMovingTool(e, toolsCopy) {
            const newIndex = this.calcToolPosition(e);
            if (this.dragStartEvent.oldIndex == newIndex) return;
            let deleteArr = toolsCopy.splice(this.dragStartEvent.oldIndex, 1);

            toolsCopy.splice(newIndex, 0, deleteArr[0]);
            this.dragStartEvent.oldIndex = newIndex;

            this.store.tools = toolsCopy;
        },
        handleWindowPointerUp(e) {
            if (this.canDelete && this.checkToolNeedToDelete(e) && this.$refs.toolBox.show) {
                const self = this;
                setTimeout(() => {
                    console.trace("delete tool");
                    self.store.tools.splice(self.dragStartEvent.oldIndex, 1);
                }, 100);
            }
            if (this.$refs.dragZone.firstChild) {
                this.$refs.dragZone.removeChild(this.$refs.dragZone.firstChild);
            }

            const lastPointToolIndex = this.calcToolPosition(e);

            if ((e && this.firstPointToolIndex == lastPointToolIndex) || !this.canDelete) {
                console.log("pointer up:", this.toolPressed);
                this.triggerTool(this.toolPressed);
            }
            this.toolPressed = null;

            window.removeEventListener(EVENT_TYPE.get(this.pointerType + ":move"), this.handleWindowPointerMove);
            window.removeEventListener(EVENT_TYPE.get(this.pointerType + ":up"), this.handleWindowPointerUp);

            this.$refs.toolbarRoot.style.pointerEvents = "auto";

            const self = this;
            setTimeout(() => {
                self.store.isPenDrag = false;
            });
        },
        setOldIndex(index) {
            this.dragStartEvent.oldIndex = index;
        },
        checkToolNeedToDelete(e) {
            const pointer = getPointer(e);
            const toolbarRect = this.$refs.toolbarRoot.getBoundingClientRect();
            switch (settingStore.toolbarPosition) {
                case 0:
                    return pointer.y + e.target.clientHeight * 0.5 < store.contentSize.height - this.store.toolbarHeight;
                case 1:
                    return pointer.x - e.target.clientWidth * 0.5 - toolbarRect.x > this.store.toolbarWidth;
                case 2:
                    return pointer.x + e.target.clientWidth * 0.5 < toolbarRect.x;
                default:
                    return false;
            }
        },
        handleAddTool(tool, e) {
            const toolsCopy = this.store.tools.slice();
            let newIndex;
            newIndex = toolsCopy.push(tool) - 1;
            this.store.tools = toolsCopy;
            this.dragStartEvent.oldIndex = newIndex;
        },
        handleToolBarPosition() {
            store.pageLeft = settingStore.toolbarPosition == 1 ? this.getToolBarWidth() : 0;
            store.pageRight = settingStore.toolbarPosition == 2 ? this.getToolBarWidth() : 0;
            EventBus.getInstance()._app.updatePageSize();

            window.dispatchEvent(new Event("resize"));
        },
        handlePointerOver() {
            focusStore.setFocusToolBar(true);
        },
        handlePointerLeave() {
            focusStore.setFocusToolBar(false);
        },
        handlePointerEnter() {
            focusStore.setFocusToolBar(true);
        },
        calcToolPosition(e) {
            const pointer = getPointer(e);
            const toolbar = this.$refs.toolbarRoot.firstChild.children;
            let newIndex = toolbar.length - 1;
            let tempWidth = 0;
            let tempHeight = 0;
            let toolPoint = 0;
            for (let i = 0; i < toolbar.length; i++) {
                switch (settingStore.toolbarPosition) {
                    case 0:
                        tempWidth += toolbar.item(i).clientWidth;

                        toolPoint = (pointer.x - store.contentSize.x) / windowContentScaleX.value;
                        //console.log(`(${e.clientX} - ${store.contentSize.x} ) / ${windowContentScaleX.value}`)
                        if (tempWidth > toolPoint) {
                            newIndex = Math.min(Math.max(i, 1), toolbar.length - 1);
                            return newIndex;
                        }
                        break;
                    case 1:
                    case 2:
                        tempHeight += toolbar.item(i).clientHeight;

                        toolPoint = (pointer.y - store.contentSize.y) / windowContentScaleY.value;
                        //console.log(`(${e.clientY} - ${store.contentSize.y} ) / ${windowContentScaleY.value}`)
                        if (tempHeight > toolPoint) {
                            newIndex = Math.min(Math.max(i, 1), toolbar.length - 1);
                            return newIndex;
                        }
                        break;
                }
            }
        },
    },
    mounted: function () {
        this.setToolsToDefault();
        store.toolbarHeight = this.$refs.toolbarRoot.offsetHeight;
        store.toggleTool[TOOLS.MEMBER_LOGIN.TOOL] = this.userData.userId.length > 0 ? true : false;

        const tools = Object.entries(TOOLS);
        tools.forEach((element) => {
            store.toolMap.set(element[1].TOOL, element[1]);
        });

        this.dragZone = this.$refs.dragZone;

        this.toolBarChildren = this.$refs.toolbarRoot;
    },
    computed: {
        checkDisabled() {
            return (tool) => {
                return store.disabledTools.includes(tool);
            };
        },
        toolbarPosition() {
            return {
                vertical: settingStore.toolbarPosition > 0,
                left: settingStore.toolbarPosition == 1,
                right: settingStore.toolbarPosition == 2,
            };
        },
        dragZoneStyle() {
            return {
                left: this.store.dragIconPoint.x + "px",
                top: this.store.dragIconPoint.y + "px",
            };
        },
        checkPageIndex() {
            return (tool) => {
                if (store.pageContent) {
                    if (tool == TOOLS.GO_RIGHT_PAGE.TOOL) {
                        if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT && store.nowPage == store.pageContent[store.nowBook].length - 1) {
                            return true;
                        } else if (store.turnPageType == TURN_PAGE_TYPE.TURN_LEFT && store.nowPage == 0) {
                            return true;
                        } else {
                            return false;
                        }
                    } else if (tool == TOOLS.GO_LEFT_PAGE.TOOL) {
                        if (store.turnPageType == TURN_PAGE_TYPE.TURN_RIGHT && store.nowPage == 0) {
                            return true;
                        } else if (store.turnPageType == TURN_PAGE_TYPE.TURN_LEFT && store.nowPage == store.pageContent[store.nowBook].length - 1) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } else {
                    return false;
                }
            };
        },
        /**
         * 過濾各版本沒有的工具
         * ※ PC的【線上更新】：因光碟版不能使用更新功能，所以會在本地寫入檔案來測試是否可以更新。
         */
        filterTools() {
            let disabledTools = [];

            switch(store.nowView) {
                case VIEW_TYPE.WEB:
                    disabledTools = WEBVIEW_TYPE_DISABLE_TOOLS.map((tool) => tool.TOOL_NAME);
                    break;
                case VIEW_TYPE.PC:
                    disabledTools = APP_DISABLE_TOOLS.map((tool) => tool.TOOL_NAME);
                    if (!store.folderPermissions.w) {
                        disabledTools.push(TOOLS.UPDATE.TOOL_NAME);
                    }
                    break;
                case VIEW_TYPE.MAC:
                    disabledTools = MAC_DISABLE_TOOLS.map((tool) => tool.TOOL_NAME);
                    break;
                case VIEW_TYPE.ANDROID:
                case VIEW_TYPE.IOS:
                    disabledTools = APP_DISABLE_TOOLS.map((tool) => tool.TOOL_NAME);
                    break;
            }

            this.store.tools = this.store.tools.filter((tool) => !disabledTools.includes(tool.TOOL_NAME));

            return this.store.tools;
        },
    },
    watch: {
        "store.nowPage": {
            handler: function () {
                this.nowPageName = store.pageContent[store.nowBook][store.nowPage].pageName;
            },
        },
        "store.nowBook": {
            handler: function () {
                this.nowPageName = store.pageContent[store.nowBook][store.nowPage].pageName;
            },
        },
        "store.singlePageMode": {
            handler: function () {
                store.toggleTool[TOOLS.PAGE_MODE.TOOL] = store.singlePageMode;
            },
        },
        "settingStore.isPenClick": {
            handler: function () {
                store.setToolToggle("pen_click", settingStore.isPenClick);
            },
        },
        "settingStore.isFixed": {
            handler: function () {
                //window.dispatchEvent(new Event("resize"));
                store.toggleTool[TOOLS.DISPLAY_TYPE.TOOL] = settingStore.isFixed == 0 ? false : true;
            },
        },
        "settingStore.isWindow": {
            handler: function () {
                AppRenderer.Instance.switchFullScreenOrWindow();
            },
        },
        "settingStore.toolbarPosition": {
            handler: function () {
                setTimeout(() => {
                    // EventBus.getInstance()._app.updatePageSize();
                    // window.dispatchEvent(new Event("resize"));

                    this.handleToolBarPosition();
                }, 100);
            },
        },
        "userData.userId": {
            handler: function () {
                store.toggleTool[TOOLS.MEMBER_LOGIN.TOOL] = this.userData.userId.length > 0 ? true : false;

                if (this.userData.userId.length > 0 && store.mergeToCloud) {
                    SaveTool._instance.showMergeConfirm();
                }

                if (this.userData.userId.length > 0 && store.fetchCloudRecord) {
                    store.fetchCloudRecord = false;
                    EventBus.getInstance().getAppRefs().userRecord.handleFetchRecord();
                }
            },
        },
    },
    created: function () {},
    // updated() {
    //     store.pageLeft = settingStore.toolbarPosition == 1 ? this.getToolBarWidth() : 0;
    //     store.pageRight = settingStore.toolbarPosition == 2 ? this.getToolBarWidth() : 0;
    //     EventBus.getInstance()._app.updatePageSize();
    //     window.dispatchEvent(new Event("resize"));
    // }
};
</script>

<style src="../css/tool_Icon.css" />
<style scoped>
#go_page_triangle {
    position: relative;
    margin-left: 2px;
    width: 16px;
    cursor: pointer;
}

#go_page_input {
    pointer-events: none;
    position: relative;
    font-size: 16px;
}

.vertical #go_page_input {
    font-size: 16px;
}

.toolbar {
    position: absolute;
    /* width: 100%; */
    width: 1457px;
    height: 8%;
    min-height: 64px;
    background-color: white;
    bottom: 0px;
    z-index: 40;

    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}

.toolbar.vertical {
    width: 3%;
    height: 100%;
    min-width: 64px;
}

.vertical.left {
    left: 0px;
}

.vertical.right {
    right: 0px;
}

.toolbar-content {
    width: 100%;
    height: 100%;
    display: flex;
}

.tool {
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
}

.go_page input {
    background: transparent;
    border: none;
    outline: none;
    text-align: center;
    font-size: 1rem;
    width: 100%;
}

.selected {
    background-color: darkgray;
}

.disabled {
    filter: grayscale(1);
    pointer-events: none;
}

.tool-zoom-corner {
    width: 100%;
    height: 70%;
    display: grid;
    grid-template-columns: 50% 50%;
}

.vertical .toolbar-content {
    flex-direction: column;
    align-items: center;
}

.dragZone {
    position: absolute;
    width: 82px;
    height: 82px;
    z-index: 9999;
    opacity: 0.5;
}

.page-selector {
    display: flex;
    align-items: center;
}
</style>
